import { render } from "./Attrition.vue?vue&type=template&id=738f67eb&scoped=true"
import script from "./Attrition.vue?vue&type=script&lang=js"
export * from "./Attrition.vue?vue&type=script&lang=js"

import "./Attrition.vue?vue&type=style&index=0&id=738f67eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738f67eb"]])

export default __exports__